import config from '@/config'
import Cookies from './cookie'

/**
 * 获取当前Access Token
 */
export const getToken = () => {
  return Cookies.get(config.accessToken)
}

/**
 * 设置access token
 */
export const setToken = (token, expire) => {
  var time = new Date(new Date().getTime() + expire * 1000)
  Cookies.set(config.accessToken, token, { expires: time, domain: config.domain})
}

/**
 * 退出清除Token
 */
export const clearToken = () => {
  localStorage.removeItem(config.accessToken)
  localStorage.removeItem('loggedIn')
  localStorage.removeItem('userRole')
  localStorage.removeItem('role')
  Cookies.remove(config.accessToken, {domain: config.domain})
  Cookies.remove(config.refreshToken, {domain: config.domain})

  return true;
}

/**
 * 监听stroage事件
 */
export const dispatchEventStroage = () => {
  const signSetItem = localStorage.setItem
  localStorage.setItem = function (key, val) {
    let setEvent = new Event('setItemEvent')
    setEvent.key = key
    setEvent.newValue = val
    window.dispatchEvent(setEvent)
    signSetItem.apply(this, arguments)
  }
}

/**
 * 中国标准时间转化为yyyy-MM-dd时间
 */
export const datepickerFormat = (date) => {
  const d = new Date(date);
  return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
}
